/* unplugin-vue-components disabled */import { render } from "./noCaptcha.vue?vue&type=template&id=11d622fd&scoped=true"
import script from "./noCaptcha.vue?vue&type=script&lang=js"
export * from "./noCaptcha.vue?vue&type=script&lang=js"

import "./noCaptcha.vue?vue&type=style&index=0&id=11d622fd&scoped=true&lang=css"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d622fd"]])

export default __exports__